import { ChangeDetectorRef, Component, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { NgbActiveModal, NgbModalOptions } from '@ng-bootstrap/ng-bootstrap';
import { UploadFilesService } from '../uploadFiles.service';
import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'app-create-edit-files-box',
  templateUrl: './create-edit-files-box.component.html',
  // styleUrls: ['./create-edit-files-box.component.scss']
})
export class CreateEditFilesBoxComponent implements OnInit { 

  private fileBoxComponent: CreateEditFilesBoxComponent;

  @Output() saved = new EventEmitter<any>();
  @Output() displayFileName = new EventEmitter<any>();
  @Input() fileType;

  @Input() allowedFileTypes;
  @Input() allowedDocumentTypes;

  private output = new EventEmitter<UploadDocumentFile>();

  documentAcceptedFormats = [];

  imageTypes = ['png', 'jpg', 'jpeg'];

  //modalSize: ModalSize = 'lg';
  isModalOpen = false;
  // displayName = '';

  public uploadDocumentFile = {} as UploadDocumentFile;

  modalOptions: NgbModalOptions = {
    size: 'md',
    backdrop: 'static',
    scrollable: true,
    centered: true,
    windowClass: 'fileBoxPopup',
  };


  fileError = false;
  saveButtonDisabled = true;
  loading: boolean;
  submitted: boolean;
  localimageview: any;


  constructor(public uploadService: UploadFilesService, private activeModel: NgbActiveModal,private toastr: ToastrService) {
  }

  ngOnInit() {
    this.uploadService.filePreview = false;
    // this.uploadService.imageUrl = '';
    this.uploadDocumentFile.displayName = '';
  }

  show(fileTypes: any, documentType: any, fileType: string) {

    this.allowedFileTypes = fileTypes;
    this.allowedDocumentTypes = documentType;
    this.fileType = fileType;
    this.uploadService.filePreview = false;
    this.uploadService.imageUrl = '';



    this.uploadDocumentFile.displayName = '';
    this.isModalOpen = true;
  }

  onFileChange(event) {

    this.uploadDocumentFile.file = event.target.files[0];



    if (this.fileType == 'both') {
      this.documentAcceptedFormats = this.allowedFileTypes.concat(this.allowedDocumentTypes);
    }

    if (this.fileType == 'document') {
      this.documentAcceptedFormats = this.documentAcceptedFormats.concat(this.allowedDocumentTypes);
    }

    if (this.fileType == 'image') {
      this.documentAcceptedFormats = this.documentAcceptedFormats.concat(this.allowedFileTypes);
    }

    if (this.uploadDocumentFile.file) {
      if (this.documentAcceptedFormats.indexOf(this.uploadDocumentFile.file.name.split('.').pop().toLowerCase()) !== -1) {
        if (this.imageTypes.indexOf(this.uploadDocumentFile.file.name.split('.').pop().toLowerCase()) !== -1) {
          this.uploadService.filePreview = true;
        }
        else {
          this.uploadService.filePreview = false;
        }
        console.log('Allow this file');

        let reader = new FileReader();

        reader.onload = (event: any) => {
          this.localimageview = event.target.result;
        };

        reader.readAsDataURL(event.target.files[0]);

        this.fileError = false;
        this.saveButtonDisabled = false;
      }
      else {
        event = null;
        this.saved.emit();
        this.displayFileName.emit();
        this.fileError = true;
        this.saveButtonDisabled = true;
      }
    }
  }

  save() {
    if (!this.uploadDocumentFile || !this.uploadDocumentFile.file) {
      this.submitted = true;
      this.toastr.error('Please upload a valid file.', 'Error');
      return;}
      if(this.fileError) {
        this.toastr.error('Please upload a valid file.', 'Error')
        return;
      }
    if(this.uploadDocumentFile)
    this.loading = true;
    this.uploadService.imageUrl = this.localimageview;
    this.activeModel.close(this.uploadDocumentFile);
    this.loading = false;
    this.isModalOpen = false;
  }
  close() {
    this.activeModel.close(false);
  }

}

interface UploadDocumentFile {
  displayName: string;
  file: any;
}